import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OtSummaryComponent} from './ot-summary.component';
import {routing} from './ot-summary.routing';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {OtDetailsService} from '../operation-theater/ot-details/ot-details.service';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {PanelModule} from 'primeng/primeng';
import {PreOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/pre-operative-instruction-details/pre-operative-instruction-details.service';
import {StaffDetailsService} from '../operation-theater/ot-schedule/staff-details/staff-details.service';
import {EquipmentDetailsService} from '../operation-theater/ot-schedule/equipment-details/equipment-details.service';
import {IntraOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/intra-operative-instruction-details/intra-operative-instruction-details.service';
import {ProcedureDetailsService} from '../operation-theater/ot-schedule/procedure-details/procedure-details.service';
import {ChecklistDetailsService} from '../operation-theater/ot-schedule/checklist-details/checklist-details.service';
import {PostOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/post-operative-instruction-details/post-operative-instruction-details.service';
import {ConcentDetailsService} from '../operation-theater/ot-schedule/concent-details/concent-details.service';
import {DoctorDetailsService} from '../operation-theater/ot-schedule/doctor-details/doctor-details.service';
import {ServiceDetailsService} from '../operation-theater/ot-schedule/service-details/service-details.service';
import {LayoutModule} from '../layout/layout.module';

@NgModule({
    imports: [
        CommonModule, routing, SharedTranslationModule, PanelModule,LayoutModule
    ],
    declarations: [OtSummaryComponent],
    providers: [MstVisitService, MstUnitService, OtDetailsService, ChecklistDetailsService, ProcedureDetailsService,
        ConcentDetailsService, EquipmentDetailsService, PreOperativeInstructionDetailsService,
        IntraOperativeInstructionDetailsService, PostOperativeInstructionDetailsService, DoctorDetailsService,
        StaffDetailsService, ServiceDetailsService]
})
export class OtSummaryModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ot-summary/ot-summary.module.ts